/**
 * DevExtreme (esm/__internal/grids/new/grid_core/data_controller/deferred_cache.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    equalByValue
} from "../../../../../core/utils/common";
import {
    Deferred
} from "../../../../../core/utils/deferred";
const createDeferred = () => new Deferred;
export const deferredCache = actionFn => {
    let lastArgs = null;
    let cachedResult = null;
    return function() {
        const hasPreviousCall = null !== lastArgs && null !== cachedResult;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key]
        }
        const isArgsSame = hasPreviousCall ? equalByValue(lastArgs, args) : false;
        if (hasPreviousCall && isArgsSame) {
            return createDeferred().resolve(cachedResult)
        }
        lastArgs = args;
        return actionFn(...args).then((result => {
            cachedResult = result;
            return result
        }))
    }
};
